import { z } from 'zod';
import { NOTIFICATION_TYPES, type NotificationType } from '../constants/notifications.js';

export const notificationTypeSchema = z.enum(NOTIFICATION_TYPES);

export const listNotificationsQuerySchema = z.object({
  unreadOnly: z
    .union([z.literal('true'), z.literal('false'), z.boolean()])
    .transform((v) => v === true || v === 'true')
    .optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(30),
});
export type ListNotificationsQuery = z.infer<typeof listNotificationsQuerySchema>;

export interface NotificationDto {
  id: string;
  type: NotificationType;
  message: string;
  linkPath: string | null;
  taskId: string | null;
  boardId: string | null;
  actorId: string | null;
  actorName: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface UnreadCountResponse {
  count: number;
}

/**
 * Unified inbox unread counter. The CO sees both streams (activity +
 * financial alerts); officers see only activity. `total` is what the
 * header badge renders.
 */
export interface InboxUnreadCountResponse {
  total: number;
  activity: number;
  alerts: number;
}

/** An alert summary projected onto the inbox shape. */
export interface InboxAlertItem {
  id: string;
  type: 'LOW_BALANCE' | 'BUDGET_OVERSPEND' | 'MONTHLY_CLOSING' | 'ANOMALY';
  severity: 'INFO' | 'WARNING' | 'CRITICAL';
  fundCode: string | null;
  fundName: string | null;
  message: string;
  isRead: boolean;
  triggeredAt: string;
}

/**
 * Sectioned inbox response. `alerts` is empty for non-CO viewers.
 */
export interface InboxResponse {
  activity: NotificationDto[];
  alerts: InboxAlertItem[];
}
